module.exports = __webpack_public_path__ + "media/images/icons/linkedin-b8bed49a74aa9f7fdbeb8ab076d65be5.svg";